import { useEffect } from 'react'

function Membership() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const queryLang = params.get('lang')
    const storedLang = window.localStorage.getItem('site_lang')
    const lang = queryLang || storedLang || 'zh'

    window.location.replace(`/membership.html?lang=${encodeURIComponent(lang)}`)
  }, [])

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <p className="text-gray-600 dark:text-gray-400">正在跳转到会员权益...</p>
    </div>
  )
}

export default Membership
